export const DEFAULT_DISPLAY = '-:-';
